export default "__VITE_PUBLIC_ASSET__02dafa23__"